module.exports = __webpack_public_path__ + "img/review-img-2.837e64cb.png";